import React from 'react';
import SharedConstants from 'common/constants/SharedConstants';

export const MenuLinksComp = props => {
  const { headerLinks, onNavigateHandler, menuImageWidth, menuImageHeight } = props;

  const onKeyPressHandler = (event, name, pathname) => {
    const { SPACE, ENTER } = SharedConstants.KEY_CHAR_CODE;
    if ([SPACE, ENTER].includes(event?.charCode)) {
      onNavigateHandler(name, pathname);
    }
  };

  return (
    <div className='menu-links-container'>
      {headerLinks?.map(linkItem => (
        <div
          className='menu-link'
          key={`menu-link-${linkItem?.name}`}
          data-testid={`menu-link-${linkItem?.name}`}
          onKeyPress={event => onKeyPressHandler(event, linkItem?.name, linkItem?.pathname)}
          onClick={() => onNavigateHandler(linkItem?.name, linkItem?.pathname)}
        >
          <div data-testid={`menu-name-${linkItem?.name}`} className='menu-link-name'>
            {linkItem?.name}
          </div>
          <div            
            className='menu-link-image'
            style={{
              backgroundImage: `url(${linkItem?.imageUrl}?h=${menuImageHeight}&w=${menuImageWidth})`,
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};
